import React from 'react';
import { Loader } from 'semantic-ui-react';

const LoaderExampleInlineCentered = () => (
    <Loader active inline="centered" size="large">
        Loading
    </Loader>
);

export default LoaderExampleInlineCentered;



// WEBPACK FOOTER //
// ./src/app/components/features/share/loadingInline.js